export default __webpack_public_path__ + "static/AcidGrotesk-Regular-350dc7486590e8b1d0013ef7c66f9cde.otf";